import { Star } from "lucide-react";

const items = [
  "قرآن كريم",
  "سباحة",
  "كرة قدم",
  "البتيناج",
  "دفاع عن النفس",
  "طبخ",
  "رسم وتلوين",
  "أشغال يدوية",
  "طين وصلصال",
  "تصوير",
  "جوائز ونجوم المهرجان",
];

export default function Marquee() {
  const doubled = [...items, ...items];
  return (
    <div className="relative py-4 sm:py-6 bg-[#1E293B] text-[#FFD600] border-y-[3px] sm:border-y-4 border-[#FFD600] overflow-hidden" data-testid="marquee">
      <div className="ticker-track whitespace-nowrap">
        {doubled.map((t, i) => (
          <span key={i} className="inline-flex items-center gap-1.5 sm:gap-3 font-display font-black text-sm sm:text-2xl">
            <Star className="w-3 h-3 sm:w-5 sm:h-5 fill-[#FFD600]" />
            <span>{t}</span>
          </span>
        ))}
      </div>
    </div>
  );
}
